<div class="container">
    <ng-container  *ngFor="let step of total; let i = index; let last = last; let first = first" >
        <div [ngClass]="{'current': currentStepIndex - 1 === i, 'completed': currentStepIndex - 1> i, 'last': last, 'first': first}">
        </div>
    </ng-container>
</div>
